/**
 * @sw-package innovation
 */
window.PluginManager.register(
    'CheckoutSweetener',
    () => import('./plugin/checkout-sweetener/checkout-sweetener.plugin'),
    '[data-checkout-sweetener]'
);
